import { ModuleFE_DataMigration } from './ModuleFE_DataMigration.js';
import { ModuleFE_VolatileImport } from './ModuleFE_VolatileImport.js';
import { ModuleFE_PathwayImport } from './ModuleFE_PathwayImport.js';
import { ModuleFE_DiseaseProfileImport } from './ModuleFE_DiseaseProfileImport.js';
export const ModulePackFE_DataMigration = [
    ModuleFE_DataMigration,
    ModuleFE_VolatileImport,
    ModuleFE_PathwayImport,
    ModuleFE_DiseaseProfileImport,
];
//# sourceMappingURL=module-pack.js.map